export const SongStatus = { QUEUED: 0, PLAYING: 1, SKIPPED: 2, PLAYED: 3 };
